// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdditionalInstruments_wrapperButton__vdqOJ .AdditionalInstruments_file_block__aFaoF {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.AdditionalInstruments_rightBlock__xwR9f {
  display: flex;
  gap: 20px;
}
.AdditionalInstruments_rightBlock__info__OzRkc {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 60%;
}
.AdditionalInstruments_rightBlock__info__title__jOvA8 {
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  margin-top: 3px;
}

.AdditionalInstruments_infoBlocks__Tigrc {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.AdditionalInstruments_infoBlock__Tdgdh {
  display: flex;
  width: 100%;
  gap: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.5);
}
.AdditionalInstruments_infoBlock__top__0D6X- {
  display: flex;
  gap: 20px;
  align-items: flex-end;
}
.AdditionalInstruments_infoBlock__top__form__jD2OE {
  display: flex;
  flex-direction: column;
}
.AdditionalInstruments_infoBlock__top__form__jD2OE .AdditionalInstruments_formInputs__wBdqy {
  display: flex;
  gap: 20px;
  position: relative;
}
.AdditionalInstruments_infoBlock__main__LCZSK {
  display: flex;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
}
.AdditionalInstruments_infoBlock__bottom__w6EsA {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
}
.AdditionalInstruments_infoBlock__bottom__w6EsA a {
  display: flex;
}
.AdditionalInstruments_infoBlock__Tdgdh .AdditionalInstruments_partnerConfirm__PIw27 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.AdditionalInstruments_infoBlock__Tdgdh .AdditionalInstruments_adminConfirm__MDotV {
  display: flex;
  gap: 20px;
}

.AdditionalInstruments_infoBlock__Tdgdh:last-child {
  border-bottom: 1px solid transparent;
}

.AdditionalInstruments_overlayWrapper__7zUK4 {
  position: relative;
  width: 300px;
  height: 350px;
  border: 1px solid black;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.AdditionalInstruments_overlayWrapper__7zUK4 .AdditionalInstruments_overlay__R\\+6tJ {
  position: absolute;
  padding: 20px;
  top: 0;
  font-size: 14px;
  width: 100%;
  height: 100%;
  transform: translateY(-100%);
  opacity: 0;
  transition: all 0.5s ease, transform 0.5s ease;
}
.AdditionalInstruments_overlayWrapper__7zUK4:hover .AdditionalInstruments_overlay__R\\+6tJ {
  transform: translateY(0%);
  opacity: 1;
  background-color: rgb(255, 255, 255);
}

.AdditionalInstruments_inputSearch__list__pjOpK {
  position: absolute;
  z-index: 10;
  top: 100%;
  list-style: none;
  padding: 0;
  width: 100%;
  max-height: 200px;
  overflow: auto;
  border-radius: 8px;
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 {
  background-color: #fff;
  align-items: center;
  border: 1px solid grey;
  height: max-content;
  text-wrap: balance;
  padding: 5px;
  cursor: pointer;
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7:last-child {
  border-radius: 0 0 8px 8px;
}
@media (max-width: 768px) {
  .AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 {
    height: auto;
    text-align: center;
  }
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 a {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  color: black;
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 a:visited {
  color: black;
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 a span:first-of-type {
  font-weight: 700;
  margin-right: 5px;
}
@media (max-width: 768px) {
  .AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 a span:first-of-type {
    margin-right: 0;
  }
}
@media (max-width: 768px) {
  .AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 a {
    flex-direction: column;
    height: auto;
    align-items: center;
  }
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 img,
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 svg,
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 .AdditionalInstruments_inputSearch__icons__qUIhY {
  margin-right: 10px;
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 img {
  display: block;
  max-height: 50px;
  max-width: 100px;
}
@media (max-width: 768px) {
  .AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 img {
    max-height: 100px;
  }
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 span {
  display: block;
}
.AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 span:last-child {
  margin-left: auto;
  min-width: 100px;
}
@media (max-width: 768px) {
  .AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 span:last-child {
    margin: 0;
  }
  .AdditionalInstruments_inputSearch__list__pjOpK .AdditionalInstruments_inputSearch__item__OTxr7 span:first-child {
    margin: 0;
  }
}

.AdditionalInstruments_tabList__GTBEK {
  display: flex;
}

.AdditionalInstruments_tabItem__KSJP2 {
  display: flex;
  width: auto;
  gap: 5px;
  align-items: center;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/jobs/jobsUpdate/AdditionalInstruments/AdditionalInstruments.module.scss"],"names":[],"mappings":"AACI;EAEI,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAMA;EACI,aAAA;EACA,SAAA;AAHJ;AAKI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAHR;AASQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAPZ;;AAYA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AATJ;;AAYA;EACI,aAAA;EAEA,WAAA;EACA,SAAA;EAGA,iBAAA;EACA,oBAAA;EACA,iDAAA;AAZJ;AAcI;EACI,aAAA;EACA,SAAA;EACA,qBAAA;AAZR;AAcQ;EACI,aAAA;EACA,sBAAA;AAZZ;AAeY;EACI,aAAA;EACA,SAAA;EACA,kBAAA;AAbhB;AAoBI;EACI,aAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;AAlBR;AAqBI;EACI,aAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;EAGA,mBAAA;AArBR;AAwBQ;EACI,aAAA;AAtBZ;AA0BI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAxBR;AA2BI;EACI,aAAA;EACA,SAAA;AAzBR;;AA+BA;EACI,oCAAA;AA5BJ;;AAgCA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA7BJ;AA+BI;EACI,kBAAA;EACA,aAAA;EACA,MAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,UAAA;EACA,8CAAA;AA7BR;AAgCI;EACI,yBAAA;EACA,UAAA;EACA,oCAAA;AA9BR;;AA8EA;EACI,kBAAA;EACA,WAAA;EAEA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EAEA,iBAAA;EACA,cAAA;EACA,kBAAA;AA7EJ;AA+EI;EACI,sBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,YAAA;EAEA,eAAA;AA/ER;AAmGQ;EACI,0BAAA;AAjGZ;AAoGQ;EAjCJ;IAkCQ,YAAA;IACA,kBAAA;EAjGV;AACF;AAmGQ;EACI,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAjGZ;AAmGY;EACI,YAAA;AAjGhB;AAoGY;EACI,gBAAA;EACA,iBAAA;AAlGhB;AAoGgB;EAJJ;IAKQ,eAAA;EAjGlB;AACF;AAoGY;EArBJ;IAsBQ,sBAAA;IACA,YAAA;IACA,mBAAA;EAjGd;AACF;AAoGQ;;;EAKI,kBAAA;AApGZ;AAuGQ;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;AArGZ;AAuGY;EALJ;IAMQ,iBAAA;EApGd;AACF;AAwGQ;EACI,cAAA;AAtGZ;AAwGY;EACI,iBAAA;EACA,gBAAA;AAtGhB;AAyGY;EACI;IACI,SAAA;EAvGlB;EA0Gc;IACI,SAAA;EAxGlB;AACF;;AAgHA;EACI,aAAA;AA7GJ;;AAgHA;EACI,aAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AA7GJ","sourcesContent":[".wrapperButton {\n    .file_block {\n        // border: 1px solid;\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 10px;\n    }\n}\n\n\n.rightBlock {\n    display: flex;\n    gap: 20px;\n\n    &__info {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        width: 60%;\n\n        //\n        // padding-left: 50px;\n        // border-left: 1px solid rgba(128, 128, 128, 0.5);\n\n        &__title {\n            font-size: 1rem;\n            font-weight: 700;\n            text-align: center;\n            margin-top: 3px;\n        }\n    }\n}\n\n.infoBlocks {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.infoBlock {\n    display: flex;\n    // flex-direction: column;\n    width: 100%;\n    gap: 20px;\n\n    //\n    padding-top: 30px;\n    padding-bottom: 30px;\n    border-bottom: 1px solid rgba(128, 128, 128, 0.5);\n\n    &__top {\n        display: flex;\n        gap: 20px;\n        align-items: flex-end;\n\n        &__form {\n            display: flex;\n            flex-direction: column;\n\n\n            .formInputs {\n                display: flex;\n                gap: 20px;\n                position: relative;\n            }\n        }\n\n        &__button {}\n    }\n\n    &__main {\n        display: flex;\n        gap: 20px;\n        justify-content: flex-start;\n        align-items: center;\n    }\n\n    &__bottom {\n        display: flex;\n        justify-content: flex-start;\n        gap: 20px;\n        align-items: center;\n\n        //\n        margin-bottom: 20px;\n\n\n        a {\n            display: flex;\n        }\n    }\n\n    .partnerConfirm {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .adminConfirm {\n        display: flex;\n        gap: 20px;\n\n        // flex-direction: column;\n    }\n}\n\n.infoBlock:last-child {\n    border-bottom: 1px solid transparent;\n}\n\n\n.overlayWrapper {\n    position: relative;\n    width: 300px;\n    height: 350px;\n    border: 1px solid black;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n\n    .overlay {\n        position: absolute;\n        padding: 20px;\n        top: 0;\n        font-size: 14px;\n        width: 100%;\n        height: 100%;\n        transform: translateY(-100%);\n        opacity: 0;\n        transition: all 0.5s ease, transform 0.5s ease;\n    }\n\n    &:hover .overlay {\n        transform: translateY(0%);\n        opacity: 1;\n        background-color: rgb(255, 255, 255);\n    }\n}\n\n//поле пошуку\n// .inputSearch {\n//     position: relative;\n//     // border: 1px solid tomato;\n//     width: 100%;\n\n//     .inputSearch__icon {\n//         position: absolute;\n//         right: 10px;\n//         top: 8px;\n//         color: #888888;\n//         border: none;\n//         background-color: transparent;\n//         cursor: pointer;\n//     }\n\n//     .inputSearch__button {\n//         position: absolute;\n//         right: 10px;\n//         top: 3px;\n//         color: #888888;\n//         border: none;\n//         background-color: transparent;\n//     }\n\n//     .inputSearch__input {\n//         width: 100%;\n//         height: 32px;\n//         border: none;\n//         background-color: hsl(204, 24%, 96%);\n//         padding: 4px 4px 4px 10px;\n//         // border: 1px solid tomato;\n\n//         &::placeholder {\n//             color: #888888;\n\n//             font-size: 12px;\n//             font-weight: 400;\n//             line-height: 32px;\n//             margin-left: 10px;\n//         }\n//     }\n// }\n\n.inputSearch__list {\n    position: absolute;\n    z-index: 10;\n    // top: 110%;\n    top: 100%;\n    list-style: none;\n    padding: 0;\n    width: 100%;\n    // max-height: 500px;\n    max-height: 200px;\n    overflow: auto;\n    border-radius: 8px;\n\n    .inputSearch__item {\n        background-color: #fff;\n        align-items: center;\n        border: 1px solid grey;\n        // border-top: none;\n        height: max-content;\n        text-wrap: balance;\n        padding: 5px;\n\n        cursor: pointer;\n\n        // &:hover {\n        //     padding: 0;\n        //     transition: all 1s;\n\n        //     & a {\n        //         background-color: rgba(108, 178, 0, 0.3);\n        //     }\n\n        //     & a span {\n        //         color: rgba(108, 178, 0, 1);\n\n        //     }\n\n        //     & a img {\n        //         animation: 1s ease-in-out 0s hoverItemList;\n        //     }\n        // }\n\n        &:last-child {\n            border-radius: 0 0 8px 8px;\n        }\n\n        @media (max-width: 768px) {\n            height: auto;\n            text-align: center;\n        }\n\n        a {\n            padding: 10px 20px;\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;\n            display: flex;\n            color: black;\n\n            &:visited {\n                color: black;\n            }\n\n            & span:first-of-type {\n                font-weight: 700;\n                margin-right: 5px;\n\n                @media (max-width: 768px) {\n                    margin-right: 0;\n                }\n            }\n\n            @media (max-width: 768px) {\n                flex-direction: column;\n                height: auto;\n                align-items: center;\n            }\n        }\n\n        img,\n        svg,\n        .inputSearch__icons {\n            // height: 25px;\n            // width: 25px;\n            margin-right: 10px;\n        }\n\n        & img {\n            display: block;\n            max-height: 50px;\n            max-width: 100px;\n\n            @media (max-width: 768px) {\n                max-height: 100px;\n\n            }\n        }\n\n        & span {\n            display: block;\n\n            &:last-child {\n                margin-left: auto;\n                min-width: 100px;\n            }\n\n            @media (max-width: 768px) {\n                &:last-child {\n                    margin: 0;\n                }\n\n                &:first-child {\n                    margin: 0;\n                }\n            }\n        }\n    }\n}\n\n//стилі табів\n\n.tabList {\n    display: flex;\n}\n\n.tabItem {\n    display: flex;\n    width: auto;\n    gap: 5px;\n    align-items: center;\n    padding: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperButton": `AdditionalInstruments_wrapperButton__vdqOJ`,
	"file_block": `AdditionalInstruments_file_block__aFaoF`,
	"rightBlock": `AdditionalInstruments_rightBlock__xwR9f`,
	"rightBlock__info": `AdditionalInstruments_rightBlock__info__OzRkc`,
	"rightBlock__info__title": `AdditionalInstruments_rightBlock__info__title__jOvA8`,
	"infoBlocks": `AdditionalInstruments_infoBlocks__Tigrc`,
	"infoBlock": `AdditionalInstruments_infoBlock__Tdgdh`,
	"infoBlock__top": `AdditionalInstruments_infoBlock__top__0D6X-`,
	"infoBlock__top__form": `AdditionalInstruments_infoBlock__top__form__jD2OE`,
	"formInputs": `AdditionalInstruments_formInputs__wBdqy`,
	"infoBlock__main": `AdditionalInstruments_infoBlock__main__LCZSK`,
	"infoBlock__bottom": `AdditionalInstruments_infoBlock__bottom__w6EsA`,
	"partnerConfirm": `AdditionalInstruments_partnerConfirm__PIw27`,
	"adminConfirm": `AdditionalInstruments_adminConfirm__MDotV`,
	"overlayWrapper": `AdditionalInstruments_overlayWrapper__7zUK4`,
	"overlay": `AdditionalInstruments_overlay__R+6tJ`,
	"inputSearch__list": `AdditionalInstruments_inputSearch__list__pjOpK`,
	"inputSearch__item": `AdditionalInstruments_inputSearch__item__OTxr7`,
	"inputSearch__icons": `AdditionalInstruments_inputSearch__icons__qUIhY`,
	"tabList": `AdditionalInstruments_tabList__GTBEK`,
	"tabItem": `AdditionalInstruments_tabItem__KSJP2`
};
export default ___CSS_LOADER_EXPORT___;
